"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineEntry = void 0;
const react_1 = __importDefault(require("react"));
const atome_1 = require("../../atome");
const react_native_1 = require("react-native");
const TimelineEntry_style_1 = require("./TimelineEntry.style");
const Breakpoints_1 = require("../../../helper/Breakpoints");
function TimelineEntry({ checked = false, small = false, title, subTitle = '', infoText = '', }) {
    return (react_1.default.createElement(react_native_1.View, { style: TimelineEntry_style_1.styles.entryContainer },
        react_1.default.createElement(atome_1.Text, { style: [
                TimelineEntry_style_1.styles.title,
                checked === true || Breakpoints_1.isMobileOrTablet ? TimelineEntry_style_1.styles.greenText : {},
            ] }, title),
        react_1.default.createElement(react_native_1.View, { style: [TimelineEntry_style_1.styles.circle, small === true ? TimelineEntry_style_1.styles.circleSmall : {}] },
            react_1.default.createElement(react_native_1.View, { style: [
                    TimelineEntry_style_1.styles.circleInner,
                    checked === true ? TimelineEntry_style_1.styles.circleInnerChecked : null,
                ] }, checked === true && (react_1.default.createElement(atome_1.Icon, { icon: "timelineChecked", size: !Breakpoints_1.isMobileOrTablet ? undefined : 24 })))),
        react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobileOrTablet && TimelineEntry_style_1.styles.mobileInfo },
            react_1.default.createElement(atome_1.Text, { style: [TimelineEntry_style_1.styles.subTitle, checked === true ? TimelineEntry_style_1.styles.greenText : {}] }, subTitle),
            react_1.default.createElement(atome_1.Text, { style: [
                    TimelineEntry_style_1.styles.infoText,
                    checked === true || Breakpoints_1.isMobileOrTablet ? TimelineEntry_style_1.styles.greenText : {},
                ] }, infoText))));
}
exports.TimelineEntry = TimelineEntry;
